

/*
 * These rules are used to exclude measures if the conditions are met
 */
const EW_CONDITION_RULES = {
    blood_pressure: {blood_pressure_taken: true},
    o2_flow: {on_o2: 'y'}
}

const conditions = {
        lt: (a, b) => a < b,
        lte: (a, b) => a <= b,
        gt: (a, b) => a > b,
        gte: (a, b) => a >= b,
        eq: (a, b) => a === b,
        not: (a, b) => a !== b,

        lt2: (a, b) => 2 * (a < b),
        lte2: (a, b) => 2 * (a <= b),
        gt2: (a, b) => 2 * (a > b),
        gte2: (a, b) => 2 * (a >= b),
        eq2: (a, b) => 2 * (a === b),
        not2: (a, b) => 2 * (a !== b),

        lt3: (a, b) => 3 * (a < b),
        lte3: (a, b) => 3 * (a <= b),
        gt3: (a, b) => 3 * (a > b),
        gte3: (a, b) => 3 * (a >= b),
        eq3: (a, b) => 3 * (a === b),
        not3: (a, b) => 3 * (a !== b),

        lt4: (a, b) => 4 * (a < b),
        lte4: (a, b) => 4 * (a <= b),
        gt4: (a, b) => 4 * (a > b),
        gte4: (a, b) => 4 * (a >= b),
        eq4: (a, b) => 4 * (a === b),
        not4: (a, b) => 4 * (a !== b)
  };

const reducers = {
       and: (a, b) => a && b,
       or: (a, b) => a || b,
       add: (a, b) => a + b
  };

exports.EW_CONDITION_RULES = EW_CONDITION_RULES;
exports.conditions = conditions;
exports.reducers = reducers;
